import React from 'react';
import PropTypes from 'prop-types';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import Button from 'components/Button';
import Message from 'components/Message';
import './EmptyList.scss';

const { block } = bem('manage-services-empty-list');

function EmptyList({ header, text, button, handleAddClick }) {
  return (
    <div className={block()}>
      <Message as="h4" className="text--regular" message={header} />
      <Message as="p" className="text--light" message={text} />
      <Message as={Button} styled="link" onClick={handleAddClick} message={button} />
    </div>
  );
}

EmptyList.propTypes = {
  header: intlMessage,
  text: intlMessage,
  button: intlMessage,
  handleAddClick: PropTypes.func,
};

export default EmptyList;
